import { createWebHistory, createRouter } from "vue-router";
import routes from "./routes";
import appConfig from "../../app.config";
import store from "@/state/store";
import { routingProcess } from "@/helpers/routeHelper";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});


// API based Authentication
// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  if(routeTo.meta.authRequired) await routingProcess();
  if (routeTo.meta.requiresParams) {
    let to = await store.getters["persistItems/getNavigatedToPage"];
    if (to === routeTo.name) {
      routeTo.params = await store.getters["persistItems/getNavigationParams"];
    }
  }
  let isTokenThere = !!localStorage.getItem("token");
  let value = routeTo.matched;
  if (value.length == 0) {
    let routes = await store.getters["routeAndMenu/getRoutes"];
    if (routes.length == 0) {
      if (isTokenThere) {
        await routingProcess();
        routes = await store.getters["routeAndMenu/getRoutes"];
      }
    }
    value = routes.filter((x) => x.name === routeTo.path.split("/").pop());
    if (value.length == 0) {
      next({ name: "error-403", query: { redirectFrom: routeTo.fullPath } });
      return;
    }

    if (value[0].meta.requiresParams) {
      let params = await store.getters["persistItems/getNavigationParams"];
      next({ name: value[0].name, params: params });
    } else {
      next({ name: value[0].name });
    }
    return;
  }

  if (routeTo.meta.layout != "full") {
    await store.dispatch("layout/changeLayoutType", {
      layoutType: "vertical",
    });
  }
  if (!routeTo.meta.authRequired) {
    next();
    return;
  }
  if (!isTokenThere) {
    const backendBaseUrl = process.env.VUE_APP_BACKEND_URL;
    window.location.replace(
      `${backendBaseUrl}/api/Identity/Auth/Login?returnUrl=${backendBaseUrl}/api/Identity/Auth/AssertionConsumerService`
    );
  }

  next();
});


router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }
  document.title = routeTo.meta.title + " | " + appConfig.title;
  // If we reach this point, continue resolving the route.
  next();
});

export default router;
